export default __webpack_public_path__ + "static/media/8.229f1eec.jpg";